import { ActionableInvite, AttentionLevelType, CalendarReminderType, DigestItem, GroupedEvent, InviteStatus, ResponseType } from "gql/types";


export function computeDigestHeader(item: DigestItem) {
    let topTitle = item.itemHeader?.topTitle ?? "";
    let mainTitle = item.itemHeader?.mainTitle ?? "";
    let description = item.itemHeader?.description ?? undefined;
    let attentionLevel = item.attentionLevel;

    if (item.itemType === "actionableInvite") {
        const actionableInvite = item.content as ActionableInvite;
        const invite = actionableInvite.invite;

        // invite's status has changed, fill in client-side strings for now
        if (invite.viewerResponse?.responseType === ResponseType.Accept) {
            description = "Thanks for responding! Waiting on final details.";
            mainTitle = "REPLY SHARED";
            attentionLevel = AttentionLevelType.FamilyEvent;
        }

        if (invite.viewerResponse?.responseType === ResponseType.Reject) {
            description = "You’ve declined — we’ll take care of the rest!";
            mainTitle = "REPLY SHARED";
            attentionLevel = AttentionLevelType.Informational;
        }

        if (invite.organizerUpdate && invite.status === InviteStatus.Confirmed) {
            description = "Your Playdate is Set! Guests Will Be Notified.";
            mainTitle = "INVITE SET";
            attentionLevel = AttentionLevelType.FamilyEvent;
        }

        if (invite.organizerUpdate && invite.status === InviteStatus.Abandoned) {
            description = "You’ve Cancelled the Invite — We’ll Handle the Rest.";
            mainTitle = "INVITE ENDED";
            attentionLevel = AttentionLevelType.Informational;
        }

    }

    if (item.itemType === "groupedEvent") {
        const hasNoConfirmedPlaydates = ((item.content as GroupedEvent).playdateInvites?.filter(invite => invite.status === InviteStatus.Confirmed).length ?? 0) === 0;
        const hasNoAcceptedPlaydates = (item.content as GroupedEvent).playdateInvites?.filter(
            invite => invite.status === InviteStatus.Confirmed &&
                invite.viewerResponse &&
                invite.viewerResponse !== null &&
                invite.viewerResponse.responseType == ResponseType.Accept
        ).length == 0;
        const isCaretakerReminderType = item.mainReminderType === CalendarReminderType.Caretaker;
        const isActionRequired = item.attentionLevel === AttentionLevelType.ActionRequired || item.attentionLevel === AttentionLevelType.MayNeedAction;

        // User accepted one of the invites, so change the description and attentionLevel
        if (!hasNoAcceptedPlaydates && !hasNoConfirmedPlaydates && isActionRequired) {
            description = "Great! We will notify the organizer about your attendance."
            attentionLevel = AttentionLevelType.FamilyEvent;
        }

        // User made changes on the client since the last Digest update, optimistically change the content
        if (hasNoConfirmedPlaydates && isCaretakerReminderType && !isActionRequired) {
            description = "No plans just yet — you can set up a playdate anytime!";
            attentionLevel = AttentionLevelType.ActionRequired;
        }
    }

    return { topTitle, mainTitle, description, attentionLevel };
}
